import React, { Component } from 'react';

import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import ImagePanel from '@components/ImagePanel/ImagePanel';
import TextBox from '@components/TextBox/TextBox';
import Helmet from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import Css from '@components/Safety/Technology/Desktop/Desktop.scss';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');
const Cockpit = ImportImages('/careers/cockpit.jpg');
const cockpitEmpty = ImportImages('/safety/cockpit-empty.jpg');

class Careers extends Component {
  render() {
    let height = window.innerHeight;

    const containerProps = {
      pageHeight: height,
      autoScroll: {
        active: 1,
        delay: 1000
      }
    };

    const technologyProps = {
      header: 'Careers with JetSuite',
      content:
        'We are always on the lookout for diverse, passionate, and kind individuals for roles on the ground and in the' +
        ' air. To see a listing of available jobs and to apply, click <a' +
        ' href="https://recruiting2.ultipro.com/JET1001JETS/JobBoard/83d73bc0-3085-4441-a386-dd79dcc22eb0/?q=&o=postedDateDesc" class="red-link">here</a>. We’d' +
        ' love to' +
        ' meet you.'
    };

    let styles = {};
    let className = '';
    if (window.innerWidth < 992) {
      styles.minHeight = this.props.pageHeight + 'px';
      styles.backgroundImage = `url(${Clouds})`;
      styles.backgroundSize = '100% 100%';
      styles.backgroundPosition = 'center center';
      styles.paddingTop = '6rem';
    } else {
      styles.height = this.props.pageHeight + 'px';
      className = 'abs-container';
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Careers | JetSuite</title>
          <meta
            name="description"
            content={technologyProps.content.replace(/<(?:.|\n)*?>/gm, '')}
          />
        </Helmet>
        <ScrollContainer {...containerProps}>
          <ImagePanel
            className={'img-bottom'}
            id={'careers-imagepanel'}
            screenHeight={height}
            image={Cockpit}
            alt={'CockPit'}
          />

          <div
            id={'careers-panel'}
            className={'panel d-flex align-items-center'}
            style={styles}
          >
            <img
              src={Clouds}
              alt={'Slider1'}
              className={'img-fluid d-none d-lg-block'}
            />
            <Container
              fluid={true}
              className={className + ' d-flex align-items-center'}
            >
              <Row className={'justify-content-center'}>
                <Col md={10} xs={12}>
                  <Row>
                    <Col lg={6} xs={12}>
                      <TextBox {...technologyProps} isHeader={true} />
                    </Col>
                    <Col lg={6} xs={12}>
                      <Row
                        className={
                          Css['technology-img-wrapper'] +
                          ' asap-medium abs-content align-items-center d-none d-lg-flex'
                        }
                        style={{ overflow: 'hidden' }}
                      >
                        <img
                          src={cockpitEmpty}
                          alt={'Technology'}
                          className={'img-fluid d-md-block'}
                        />
                      </Row>

                      <img
                        src={cockpitEmpty}
                        alt={'Technology'}
                        className={'img-fluid d-block d-lg-none mt-4 mb-4'}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </ScrollContainer>
      </React.Fragment>
    );
  }
}

export default Careers;



// WEBPACK FOOTER //
// ./src/components/Careers/Careers.js